import React from 'react'
import './style.scss';
import cn from 'classnames';

export default (props) => {
  return <div {...props} className={cn("body", props.className)}>{props.children}</div>;
}
